<template>
  <div class="exchange-i">
    <Header title="指导内容" type="0" :route="'/student/to_guideRecode?ywstid='+this.$route.query.ywstid+'&type='+this.$route.query.type"></Header>
    <div class="list-head" >
      <div>
        <p>学生学号：{{this.$route.query.studentnumber}}</p>
        <p>学生姓名：{{this.$route.query.studentname}}</p>
        <p>设计（论文）题目：{{this.$route.query.topicname}}</p>
      </div>
             
      </div>
      <div class="exchange">
      <p>学生提问</p>
      <div>
        <textarea ref="textarea"  class="textarea" v-html="msg_req" v-model="msg_req"></textarea>
      </div>   
    </div>
    <div class="exchange">
      <p>导师回复</p> 
      <div>
        <textarea ref="textarea"  class="textarea" v-html="msg_resp" v-model="msg_resp"></textarea>
      </div>   
    </div>
    <div class="bottom-btn">
      <button @click="toSubmitGuide">提交审核</button>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      designReCodeList: {},
      msg_req:'',
      msg_resp:'',
      msgContext:"",
    };
  },
  methods: {
    async loadZdmsgDeal(){
      
    },
    async toSubmitGuide(){
      if(this.msg_req==''){
        this.$toast.fail("提问不能为空！");
        return false;
      }
      if(this.msg_resp==''){
        this.$toast.fail("导师回复不能为空！");
        return false;
      }
      const params = {
        ywstid: this.$route.query.ywstid,
        iswfmes:'3',
        submitPepo:'student',
        msg_req:this.msg_req,
        msg_resp:this.msg_resp,
        type:this.$route.query.type
      };
      const res = await Api.saveIswfmes_add(params);
      if(res.code=='1'){
        this.$toast.success("提交审核成功!");
        setTimeout(() => {
          this.$router.replace("/student/to_guideRecode?ywstid="+this.$route.query.ywstid+"&type="+this.$route.query.type);
        }, 1500);
      }
    },   
  },
  created() {
    //this.loadZdmsgDeal();
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .list-head {
      height: 100px;
      background-image: url("../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding-left: 6%;
      padding-top: 2%;
      box-sizing: border-box;
      margin-bottom: 1%;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      div {
        width: 90%;
        height: 100%;
        p {
          font-size: 14px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        
      }
    }
  .exchange {
    padding-left: 5%;
    padding-top: 3%;
    padding-right: 5%;
    
    height: 35vh;
    p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
     div{
      box-sizing: border-box;
      background-color: #f8f8f8;
      border-radius: 8px;
      height: 30vh;
      word-wrap: break-word;
      overflow:auto;
      padding: 5px 5px;
     }

     textarea{
      height: 100%;
      width: 100%;
     }

  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/Design/addQustMsg_unline.vue